/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Approved_ToastInputs */

const en_booking_approved_toast = /** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking officially confirmed`)
};

const es_booking_approved_toast = /** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserva confirmada oficialmente`)
};

const fr_booking_approved_toast = /** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservation officiellement confirmée`)
};

const de_booking_approved_toast = /** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchung offiziell bestätigt`)
};

const id_booking_approved_toast = /** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemesanan resmi dikonfirmasi`)
};

/** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */
const ja_booking_approved_toast = en_booking_approved_toast;

/** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */
const zh_booking_approved_toast = en_booking_approved_toast;

/** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */
const ar_booking_approved_toast = en_booking_approved_toast;

/** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */
const it_booking_approved_toast = en_booking_approved_toast;

/** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */
const ru_booking_approved_toast = en_booking_approved_toast;

/** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */
const pt_booking_approved_toast = en_booking_approved_toast;

/** @type {(inputs: Booking_Approved_ToastInputs) => LocalizedString} */
const ko_booking_approved_toast = en_booking_approved_toast;

/**
* | output |
* | --- |
* | "Booking officially confirmed" |
*
* @param {Booking_Approved_ToastInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_approved_toast = /** @type {((inputs?: Booking_Approved_ToastInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Approved_ToastInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_approved_toast(inputs)
	if (locale === "es") return es_booking_approved_toast(inputs)
	if (locale === "fr") return fr_booking_approved_toast(inputs)
	if (locale === "de") return de_booking_approved_toast(inputs)
	if (locale === "ja") return ja_booking_approved_toast(inputs)
	if (locale === "zh") return zh_booking_approved_toast(inputs)
	if (locale === "ar") return ar_booking_approved_toast(inputs)
	if (locale === "id") return id_booking_approved_toast(inputs)
	if (locale === "it") return it_booking_approved_toast(inputs)
	if (locale === "ru") return ru_booking_approved_toast(inputs)
	if (locale === "pt") return pt_booking_approved_toast(inputs)
	return ko_booking_approved_toast(inputs)
});